import { FlatButton, PrimaryButton } from 'nrcs-design-system';
import React, { useRef, useState } from 'react';
import ReactToPrint from 'react-to-print';
import stores from 'cd-eft/models/Stores';
import { mdiPrinterOutline } from '@mdi/js';
const libraryStore = stores.AppStore.projectsLibraryStore;
interface IPrintComponentProps {
    ButtonType: any;
    printButtonText: string;
    componentToPrint: any;
    componentProps: any;
    printButtonClasses?: string;
    onClick?: () => void;
    disabled?: boolean;
}
/**
 * Common component to print a supplied component through the browsers print menu.
 * @param {IPrintComponentProps} props 
 * @param {string} props.printButtonText - String to be inside the button, styled already as usa-button.
 * @param {string} props.printButtonClasses - Optional param to add additional class names to the button.
 * @param props.componentToPrint - The component to be printed.
 * @param {object} [props.componentProps] - The props of the componentToPrint 
 * @returns 
 */
export const PrintComponent = (props: IPrintComponentProps) => {
    const buttonClasses = props.printButtonClasses ? props.printButtonClasses : '';
    const componentRef = useRef(null);
    const [isReportReady, setReportReady] = useState(false);
    const [printButtonClicked, setPrintButtonClicked] = useState(false);

    const button = props.ButtonType === "FlatButton"
        ? <FlatButton iconLeft={mdiPrinterOutline} disabled={props.disabled}
        >{props.printButtonText}</FlatButton>
        : props.ButtonType === "PrimaryButton" 
        ? <PrimaryButton iconLeft={mdiPrinterOutline} className={`usa-button ${buttonClasses}`} disabled={props.disabled}>{props.printButtonText}</PrimaryButton>
        : <button className={`usa-button ${buttonClasses}`} disabled={props.disabled}>{props.printButtonText}</button>;

    const fetchReportContent = () => {
        setPrintButtonClicked(true);
        return new Promise((resolve) => {
            libraryStore.isLoading = true;
            const checkReportGeneration = () => {
                if (libraryStore.isReportGenerated) {
                    setReportReady(true);
                    resolve(true);
                } else {
                    setTimeout(checkReportGeneration, 100); // Check every 100ms
                }
            };

            checkReportGeneration();

        });
    };
    const handleAfterPrint = () => {
        libraryStore.isLoading = false;
        libraryStore.isReportGenerated = false;
        setPrintButtonClicked(false);
        setReportReady(false);
    };


    return (
        <>
            <ReactToPrint
                trigger={() => button}
                content={() => componentRef.current}
                onBeforeGetContent={fetchReportContent}
                onBeforePrint={() => {
                    if (!isReportReady) {
                        return Promise.reject();
                    }
                }}
                onAfterPrint={handleAfterPrint}
            />
            <div hidden={true}>
                <RefWrapperComponent
                    ref={componentRef}
                    componentProps={{ ...props.componentProps, printButtonClicked, setPrintButtonClicked }}
                    componentToPrint={props.componentToPrint}
                />
            </div>
        </>
    )
}

interface IWrapperProps {
    componentToPrint: any;
    componentProps: any;
}
/**
 * Wrapper for the component to be printed that adds the containing ref atrribute to the div
 */
const RefWrapperComponent = React.forwardRef((props: IWrapperProps, ref) => {
    return (
        <div ref={ref as React.MutableRefObject<null>}>
            <props.componentToPrint {...props.componentProps} />
        </div>
    )
})